import React, { useState, useContext } from 'react';
import { Avatar, Alert, Grid, Button, TextField, Typography, Container, LinearProgress, Snackbar, Dialog, Card, CardHeader, CardContent, Paper, Divider, withStyles, CardActions } from '@mui/material';
import { config } from './App';
import { useUserAuthMutation } from 'services/user'
import * as service from './service';
import { useDispatch, useSelector } from 'react-redux';
import { setContactUs } from 'api/session';
import ContactPopUp from 'components/contact-popup';

const SignIn = () => {
  const { setSignIn, signIn } = useContext(config);
  const contactUs = useSelector(state => state.session.contactUs);
  const [inputs, setInputs] = useState({ username: '', password: '', newPassword: '' });
  const [newPassword, setNewPassword] = useState(false);
  const [lp, setLp] = useState(false);
  const [sb, setSB] = useState({ open: false, message: '', duration: 3000 });
  const [session, setSession] = useState();
  const [userAuth, { isLoading: isUpdating }] = useUserAuthMutation();
  const dispatch = useDispatch();

  const handleSubmit = () => {

    setLp(true);
    service.login(inputs, session)
      .then(result => {
        if (result.challengeName === "NEW_PASSWORD_REQUIRED") {
          setNewPassword(true);
          setSession(result);
          setLp(false);
        } else {

          if (result.message) {
            setLp(false);
            setSB({ ...sb, open: true, message: result.message });
          } else {
            setNewPassword(false);
            setInputs({ ...inputs, newPassword: "" })
            setLp(false);
            if (result?.email) {
              setSignIn({
                ...signIn,
                isAuthenticated: true,
                cognitoId: result.sub,
                user: result.email,
                fName: result.given_name,
                lName: result.family_name,
                phone: result.phone_number,
                userType: result.role
              });

            }
          }
        }
      })
      .catch(err => {
        console.log("err", err)
      })

  }

  const handleClose = () => {
    setSB({ ...sb, open: false });
  };


  return (
    <React.Fragment>

      <Container maxWidth={false} sx={{ background: "#000" }} disableGutters>

        <Grid container justifyContent="center" alignItems={'center'}
          sx={{
            // width: "100vw",
            height: "100vh",
          }}
        >
          <Grid container item xs={5} justifyContent="center">
            <Card elevation={0}
              sx={{
                backgroundColor: "transparent"
              }}
            >
              <Grid container display="flex" direction="column" alignItems="center" justifyContent="center">
                <Avatar variant="square" color="success" src="https://tirefax.s3.us-west-2.amazonaws.com/images/tirefax.png"
                  sx={{
                    margin: "10px",
                    padding: "10px",
                    width: {
                      lg: "420px",
                      md: "210px",
                      sm: "150px"
                    },
                    height: {
                      sm: "60px",
                      lg: "200px",
                      md: "105px"
                    },
                    backgroundColor: "#eeeeee",
                    borderRadius: "10px"
                  }}
                />
                <Typography
                  sx={{
                    color: "#E2E2E6",
                    fontSize: {
                      lg: "24px",
                      md: "18px",
                      sm: "16px"
                    }
                  }}
                  align='center'>
                  Admin Control Panel
                </Typography>
              </Grid>
            </Card>
          </Grid>

          <Divider orientation="vertical"
            sx={{
              background: "#E2E2E6",
              width: "1px",

            }}
          />

          <Grid container item xs={6} justifyContent="center">
            {newPassword ?
              <Card elevation={2} sx={{ backgroundColor: "#272D34", width: { lg: '50%', md: "70%", sm: "85%" } }}>
                {lp ? <LinearProgress /> : <div />}
                <CardHeader
                  title={
                    <Typography variant='subtitle1' sx={{ color: "#E2E2E6", fontSize: "16px" }} align='center'>Set New Password</Typography>
                  }
                />
                <CardContent sx={{ margin: 1 }}>
                  <Typography sx={{ color: "#E2E2E6", fontSize: "12px", marginTop: "20px" }} align='left'>New Password</Typography>
                  <TextField
                    fullWidth required label="" name="newPassword"
                    type="password" value={inputs.newPassword} autoComplete="current-password" margin="normal" variant="outlined"
                    onChange={(event) => setInputs({ ...inputs, newPassword: event.target.value })}

                    sx={{
                      border: '1px solid #E2E2E6',
                      borderRadius: 1
                    }}

                    InputProps={{
                      style: {
                        borderRadius: 2,
                        color: "#E2E2E6",
                        fontSize: "16px"
                      }
                    }}


                  />

                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      width: "100%",
                    }}
                    variant="contained"
                    color='primary'
                    type="submit"
                    onClick={() => handleSubmit()}
                  >
                    Set New Password
                  </Button>
                </CardActions>
              </Card>
              :

              <Card elevation={2} sx={{ backgroundColor: "#272D34", width: { lg: '50%', md: "70%", sm: "85%" } }}>
                {lp ? <LinearProgress /> : <div />}
                <CardHeader title={<Typography variant='subtitle1' sx={{ color: "#E2E2E6", fontSize: "16px" }} align='center'>Sign In</Typography>} />
                <CardContent sx={{ margin: 1 }}>
                  <Typography variant='body1' sx={{ color: "#E2E2E6", fontSize: "12px" }} align='left'>E-Mail</Typography>
                  <TextField
                    fullWidth
                    required
                    label=""
                    name="username"
                    value={inputs.username}
                    onChange={(event) => setInputs({ ...inputs, username: event.target.value })}
                    autoComplete="email"
                    autoFocus
                    variant="outlined"
                    margin="normal"
                    sx={{
                      border: '1px solid #E2E2E6',
                      borderRadius: 1
                    }}
                    InputProps={{
                      style: {
                        borderRadius: 2,
                        color: "#E2E2E6",
                        fontSize: "16px"
                      }
                    }}
                  />
                  <Typography sx={{ color: "#E2E2E6", fontSize: "12px", marginTop: "20px" }} align='left'>Password</Typography>
                  <TextField

                    fullWidth
                    required
                    label=""
                    sx={{
                      border: '1px solid #E2E2E6',
                      borderRadius: 1
                    }}
                    InputProps={{
                      style: {
                        borderRadius: 2,
                        color: "#E2E2E6",
                        fontSize: "16px"
                      }
                    }}
                    name="password"
                    type="password"
                    value={inputs.password}
                    autoComplete="current-password"
                    margin="normal"
                    variant="outlined"
                    onChange={(event) => setInputs({ ...inputs, password: event.target.value })}
                  />

                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      width: "100%",
                    }}
                    variant="contained"
                    color='primary'
                    type="submit"
                    onClick={() => handleSubmit()}
                  >
                    Sign In
                  </Button>
                </CardActions>
                <Typography sx={{ color: "#E2E2E6", fontSize: "18px", marginTop: "40px" }} align='center'>Not a User?</Typography>
                <CardActions>
                  <Button
                    sx={{
                      width: "100%",
                    }}
                    variant="contained"
                    color='primary'
                    type="submit"
                    onClick={() => dispatch(setContactUs(true))}
                  >
                    Contact Us Here
                  </Button>
                </CardActions>
              </Card>
            }


          </Grid>
        </Grid>
      </Container>
      <Dialog anchor={"top"} open={contactUs} onClose={() => dispatch(setContactUs(false))}>
        <ContactPopUp />
      </Dialog>
      <Snackbar
        color='error'
        open={sb.open}
        autoHideDuration={sb.duration}
        onClose={handleClose}
        message={sb.message}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {sb.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}


export default SignIn;